import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RankPage } from "@/features/public/Rank";

export const Route = createFileRoute("/rank")({
  validateSearch: z.object({ uuid: z.string().optional() }),
  component: RankPage,
});
